module.exports = __webpack_public_path__ + "static/media/download.d105d5bc.svg";